import { CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  Flex,
  IconButton,
  useColorModeValue,
  useDisclosure,
  Button,
  Image,
  Spacer,
} from "@chakra-ui/react";
import { DesktopNav } from "./DesktopNav";
import { useNavigate } from "react-router-dom";

export default function Menu() {
  const { isOpen, onToggle } = useDisclosure();
  const navigate = useNavigate();

  const handleSignOut = () => {
    window.localStorage.removeItem("accessToken");
    navigate("/");
  };

  return (
    <Flex
      bg={useColorModeValue("white", "gray.800")}
      color={useColorModeValue("gray.600", "white")}
      minH={"60px"}
      py={{ base: 2 }}
      px={{ base: 4 }}
      borderBottom={1}
      borderStyle={"solid"}
      borderColor={useColorModeValue("gray.200", "gray.900")}
      align={"center"}
    >
      <Flex
        flex={{ base: 1, md: "auto" }}
        ml={{ base: -2 }}
        display={{ base: "flex", md: "none" }}
      >
        <IconButton
          onClick={onToggle}
          icon={
            isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
          }
          variant={"ghost"}
          aria-label={"Toggle Navigation"}
        />
      </Flex>
      <Flex flex={{ base: 1 }} justify={{ base: "center", md: "start" }}>
        <Image src="./imgs/logo.png" alt="Sở TNMT Bà Rịa - Vũng Tàu" w="50px" />
        <Flex
          display={{ base: "none", md: "flex" }}
          ml={10}
          alignItems="center"
        >
          <DesktopNav />
        </Flex>
        <Spacer />
        <Button variant="outline" fontSize="14px" onClick={handleSignOut}>
          Đăng xuất
        </Button>
      </Flex>
    </Flex>
  );
}
